export default "__VITE_ASSET__DgBVCv2J__"